/**
 * @generated SignedSource<<aaec8e7bdba2574fff39b7017e7c18ce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NotificationsSet1onNotification1WhitelistMutation$variables = {
  input: ReadonlyArray<string>;
};
export type NotificationsSet1onNotification1WhitelistMutation$data = {
  readonly updateSettings: {
    readonly viewer: {
      readonly settings: {
        readonly impending1on1NotificationMeetingsWhitelist: ReadonlyArray<{
          readonly end: string | null;
          readonly guid: string;
          readonly id: string;
          readonly start: string | null;
          readonly title: string;
        }>;
      };
    } | null;
  } | null;
};
export type NotificationsSet1onNotification1WhitelistMutation$rawResponse = {
  readonly updateSettings: {
    readonly viewer: {
      readonly id: string;
      readonly settings: {
        readonly impending1on1NotificationMeetingsWhitelist: ReadonlyArray<{
          readonly end: string | null;
          readonly guid: string;
          readonly id: string;
          readonly start: string | null;
          readonly title: string;
        }>;
      };
    } | null;
  } | null;
};
export type NotificationsSet1onNotification1WhitelistMutation = {
  rawResponse: NotificationsSet1onNotification1WhitelistMutation$rawResponse;
  response: NotificationsSet1onNotification1WhitelistMutation$data;
  variables: NotificationsSet1onNotification1WhitelistMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "impending1on1NotificationMeetingsWhitelist",
        "variableName": "input"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserSettings",
  "kind": "LinkedField",
  "name": "settings",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "impending1on1NotificationMeetingsWhitelist",
      "plural": true,
      "selections": [
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "guid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "title",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsSet1onNotification1WhitelistMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSettingsMutation",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsSet1onNotification1WhitelistMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserSettingsMutation",
        "kind": "LinkedField",
        "name": "updateSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Viewer",
            "kind": "LinkedField",
            "name": "viewer",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fcc1b0b479cd8d740ffcf9ee1c31d429",
    "id": null,
    "metadata": {},
    "name": "NotificationsSet1onNotification1WhitelistMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationsSet1onNotification1WhitelistMutation(\n  $input: [ID!]!\n) {\n  updateSettings(input: {impending1on1NotificationMeetingsWhitelist: $input}) {\n    viewer {\n      settings {\n        impending1on1NotificationMeetingsWhitelist {\n          id\n          guid\n          title\n          start\n          end\n        }\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "38c555c0f267dfe5ffa5071aaba6fb7a";

export default node;
